import i18n from 'modules/core/lib/i18n'

import { TaskDefinition } from 'modules/inbox_tasks/lib/abstraction'
import { peerAssignmentUrl } from 'modules/performance_process/lib/urls'

export const PeerAssignmentTaskDefinition: TaskDefinition<'PerformanceReviewProcessMaterializedTarget'> =
  {
    taskableTypename: 'PerformanceReviewProcessMaterializedTarget',
    getUrl: ({ info, navigation }) => {
      const reviewProcessId = info.performanceReviewProcess?.id

      if (!reviewProcessId) {
        return null
      }

      return peerAssignmentUrl(navigation, reviewProcessId)
    },
    getTitle: ({ groupedCount, affecteeName }) => {
      if (groupedCount && groupedCount > 1) {
        return i18n.t('tasks.inbox.titles.peer_assignement_grouped', {
          affecteeName,
          count: groupedCount - 1,
        })
      }

      return i18n.t('tasks.inbox.titles.peer_assignement', {
        affecteeName,
      })
    },
    getMetadata: ({ info }) => {
      return [info.performanceReviewProcess?.name ?? '']
    },
  }
